<template>
    <b-form-input
        :state="input_state"
        :value="value"
        v-bind="$attrs"
        v-on="inputListeners"
    ></b-form-input>
</template>

<script>
import VuexInputFieldMixin from "./VuexInputFieldMixin";

export default {
    name: "OTextInput",
    mixins: [VuexInputFieldMixin(false)],
};
</script>

<style scoped></style>
